import { AuthenticationContainer, StyledLoginFormContainer } from "../../components";
import type { AuthenticationTokenRequestData } from "../../schemas";

import { LoginTokenForm } from "./login-token-form";

export interface LoginTokenTemplateProps {
	readonly onSubmit: (data: AuthenticationTokenRequestData) => Promise<void>;
	readonly isError: boolean;
}

export const LoginTokenTemplate: React.FC<LoginTokenTemplateProps> = ({ onSubmit, isError }) => {
	return (
		<AuthenticationContainer>
			<StyledLoginFormContainer maxWidth="sm">
				<LoginTokenForm onSubmit={onSubmit} isError={isError} />
			</StyledLoginFormContainer>
		</AuthenticationContainer>
	);
};
